var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useMemo } from 'react';
import { TripType, usePrevious, useSearch } from '@honeycomb/data';
import { useBreakpoints } from '@honeycomb/ui-core';
import { getDayDiff } from '../../utils/date-utils';
export const targetingTypenameLookup = {
    [TripType.Holiday]: 'Holiday',
    [TripType.Hotel]: 'Hotel',
    [TripType.Transfer]: 'Transfer',
    [TripType.Flight]: 'Flight',
};
export const targetingDateFormat = (date) => {
    const medDate = new Date(date).toLocaleDateString(undefined, { dateStyle: 'medium' });
    return `${medDate.substring(3, 6)} ${medDate.substring(0, 2)}, ${medDate.substring(7, 11)}`;
};
export function P195Leaderboard(_a) {
    var _b, _c;
    var { displayId, isLast } = _a, other = __rest(_a, ["displayId", "isLast"]);
    const { mediumUp, largeUp } = useBreakpoints();
    const screenSize = largeUp ? 'L' : mediumUp ? 'M' : 'S';
    const prevScreenSize = usePrevious(screenSize);
    const [searchState] = useSearch([]);
    const { destinations, destinationTitle } = searchState;
    const destTitle = (_c = (_b = destinations === null || destinations === void 0 ? void 0 : destinations[0]) === null || _b === void 0 ? void 0 : _b.title) !== null && _c !== void 0 ? _c : destinationTitle;
    const targeting = useMemo(() => {
        var _a, _b;
        const isHoliday = searchState.tripType === TripType.Holiday;
        return Object.assign(Object.assign({}, (isLast
            ? {
                Destination: [`${destTitle}`],
                DepartureDate: [`${targetingDateFormat(searchState.startDate)}`],
                ReturnDate: [`${targetingDateFormat(searchState.endDate)}`],
                Adults: [`${searchState.rooms.reduce((acc, room) => acc + room.adults, 0)}`],
                Kids: [`${searchState.rooms.reduce((acc, room) => acc + room.childAges.length, 0)}`],
                Nights: [
                    `${(_a = searchState.numberOfNights) !== null && _a !== void 0 ? _a : getDayDiff(searchState.startDate, searchState.endDate)}`,
                ],
                HolidayType: [
                    `${searchState.tripType ? targetingTypenameLookup[searchState.tripType] : 'undefined'}`,
                ],
            }
            : {})), (isHoliday
            ? {
                Departure: searchState.departureAirports,
                DepartureAirport: searchState.departureAirports,
                DestinationAirport: (_b = searchState.arrivalAirports) !== null && _b !== void 0 ? _b : [],
            }
            : {}));
    }, [isLast, searchState, destTitle]);
    useEffect(() => {
        if (screenSize !== prevScreenSize) {
            window.googletag.cmd.push(() => {
                window.googletag.pubads().refresh();
            });
        }
    }, [screenSize, prevScreenSize]);
    useEffect(() => {
        const windowGoogletagPubads = () => {
            const pubads = window.googletag.pubads();
            Object.entries(targeting).forEach(([key, value]) => {
                pubads.setTargeting(key, value);
            });
            return pubads;
        };
        window.googletag.cmd.push(() => {
            windowGoogletagPubads();
            if (isLast) {
                // Collapse empty divs and enable services
                window.googletag.pubads().collapseEmptyDivs();
                window.googletag.enableServices();
            }
            window.googletag.display(displayId);
            if (isLast)
                window.googletag.pubads().refresh();
        });
    }, [destTitle, displayId, targeting, isLast]);
    return React.createElement("div", Object.assign({ id: displayId }, other));
}
